import { FirebaseReducer } from 'react-redux-firebase';

import { User } from './classes';

type UserProfile = Partial<User> | FirebaseReducer.Profile<User> | null | undefined;
type AuthProfile = Partial<FirebaseReducer.AuthState> | null | undefined;

export function getCurrentUserIdentity(profile: UserProfile, auth: AuthProfile) {
  return {
    userId: profile?.userID || auth?.uid || '',
    organizationId: profile?.organizationID || profile?.organization || ''
  };
}
